import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../services';
import { search, SearchFeild } from '../../Common';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { estateGTNFactoriesSchemaObject } from '../estateGTNFactoriesSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { TextField } from '@material-ui/core';
import FileBase64 from 'react-file-base64';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import Chip from '@material-ui/core/Chip';

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const screenCode = 'ESTATEGTNFACTORIES'

export function Listing(props) {
    const [gang, setGang] = useState([]);
    const [gangSearch, setGangSearch] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0
    });
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [devisions, setDevisions] = useState()
    const [fields, setFeilds] = useState()
    const [isTableHide, setIsTableHide] = useState(true);
    const contentRowNames = ["divisionName", "factoryName", "isActive"]
    const [errors, setErrors] = useState({});
    const [open, setOpen] = React.useState(false);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const schema = Joi.object(estateGTNFactoriesSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [gangSearch.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions()
        )
    }, [gangSearch.operationEntityID])


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWESTATEGTNFACTORIES');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITESTATEGTNFACTORIES');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setGangSearch({
            ...gangSearch,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        getAllGroups();
    }
    async function getDevisions() {
        const result = await services.getDivisions(gangSearch.operationEntityID)
        setDevisions(result)
    }
    async function getEstates() {
        var data = await services.getEstatesByGroupID(gangSearch.groupID);
        setEstates(data)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    async function handleClick(data) {
        const response = await services.EstateGTNFactoriesDelete(data.gtnFactoryMappingID)
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
        setOpen(false);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true })
            }, 1500);
            handleSearch()
        }
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }
    async function getEstateGTNFactories(operationEntityID, collectionPointID) {
        const data = await services.getEstateGTNFactoriesList(operationEntityID, collectionPointID);
        return data;
    }

    async function handleSearch() {

        destroyDataTable();
        var data = await getEstateGTNFactories(gangSearch.operationEntityID, gangSearch.collectionPointID);
        if (data !== []) {
            setIsTableHide(false);
        }
        setGang(data);
        createDataTable();

    }

    function handleGroupChange(target) {
        validateInputs(target);

        setGangSearch({
            ...gangSearch,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0'
        })
    }

    function handleEstateChange(target) {
        validateInputs(target);
        setGangSearch({
            ...gangSearch,
            operationEntityID: target.value,
            collectionPointID: '0'
        })
    }
    function handleDivisionChange(target) {
        validateInputs(target);
        setGangSearch({
            ...gangSearch,
            collectionPointID: target.value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, estateGTNFactoriesSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)

    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setGangSearch({
            ...gangSearch,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: '0'
        });
        destroyDataTable();
        setGang([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function handleClose() {
        setOpen(false);
      }

      function handleClickOpen() {
        setOpen(true);
      }
    

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Estate GTN Factories"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Add Estate GTN Factories"
                                    path="EstateGTNFactories/addEdit" />
                            </div>
                            <hr />

                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={gangSearch.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={gangSearch.operationEntityID}
                                            onChange={(e) => handleEstateChange(e.target)}>

                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={gangSearch.collectionPointID}
                                            onChange={(e) => handleDivisionChange(e.target)}>
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(devisions)}
                                        </Select>
                                    </div>


                                </div>
                                <div className="form-group row">
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={(e) => handleSearch(e)}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />

                                </div>

                            </form>

                            <div className="table-responsive row-top-gap" >
                                <table className="display dataTable no-footer" hidden={isTableHide}>
                                    <thead>
                                        <tr>
                                            <th>Division</th>
                                            <th>Factory</th>
                                            <th>Status</th>
                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {gang.map((row, index) => (
                                            <tr>
                                                <td>{row.divisionName}</td>
                                                <td>{row.factoryName}</td>
                                                <td>{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</td>
                                                <td>
                                              <IconButton
                                                variant="outlined"
                                                color="primary"
                                                onClick={handleClickOpen}
                                                hidden = {false}
                                                >
                                                <DeleteIcon/>
                                            </IconButton>
                                            <Dialog
                                                open={open}
                                                onClose={handleClose}
                                                aria-labelledby="alert-dialog-title"
                                                aria-describedby="alert-dialog-description"
                                            >
                                            <DialogTitle id="alert-dialog-title">{"Delete "}</DialogTitle>
                                            <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                                 Are you sure you want to Delete?
                                            </DialogContentText>
                                            </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleClose} color="primary">
                                                         No
                                                    </Button>
                                                    <Button onClick={() => handleClick(row)} color="primary" autoFocus>
                                                        Yes
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>  
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    )


}